import UI from './utils/UI'

UI({
  component: '.js-farmerLink'
}, ({ component, animatedIcon }) => {
  component.addEventListener('click', () => {
    const name = component.getAttribute('data-farmer-name')
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'farmerClicked', farmerName: name })
  })
})
